export default class ValidatePassword {
    constructor() {
        this.password_regex_global = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-!$%^&£€#¥§*()_+|~=`{}\[\]:\";'<>?,.\/]).{8,64}$/;
        this.password_regex = {
            nb_chars: /^.{8,64}$/,
            upper: /(?=[A-Z])./,
            lower: /(?=[a-z])./,
            number: /(?=.*[0-9])./,
            spe: /(?=[-!$%^&£€#¥§*()_+|~=`{}\[\]:\";'<>?,.\/])./,
        };
        this.password = null;
    }

    setPassword(password) {
        this.password = password;
    }

    isValid() {
        return this.password_regex_global.test(this.password);
    }

    testPart(type) {
        return this.password_regex[type].test(this.password);
    }
}
